const convertSlugToNormalText = (str = '') => {
  return str.trim().split('-').join(' ').toLowerCase();
}

export default convertSlugToNormalText
